import PropTypes from 'prop-types';

const propType = {
  url: PropTypes.string,
  medium: PropTypes.string,
  thumb: PropTypes.string,
};

const defaultProp = {
  url: '',
  medium: '',
  thumb: '',
};

export default { propType, defaultProp };
